import { useTranslation } from "react-i18next";
import Tabs from "../../../components/Tabs";

import AwaitingCompanies from "../../../features/companies/Awaiting";
import Companies from "../../../features/companies/List";
import { InfoBarPanel } from "../../../features/info-bar/admin/InfoBarPanel";
import Statistics from "../../../features/statistics/SuperAdminStats";
import { WeeklyPublicationStats } from "../../../features/statistics/SuperAdminStats/WeeklyPublicationStats";
import UsersChangeLog from "../../../features/users/super-admin/ChangeLog";

const Dashboard = () => {
	const { t } = useTranslation();

	const tabs = [
		{
			label: t("registrations"),
			content: <AwaitingCompanies />,
		},
		{
			label: t("base"),
			content: <Companies />,
		},
		{
			label: t("statistics"),
			content: <Statistics companyId="" />,
		},
		{
			label: t("users_registry"),
			content: <UsersChangeLog companyId="" />,
		},
		{
			label: "DAU/MAU",
			content: <WeeklyPublicationStats companyId="" />,
		},
		{
			label: "info bar",
			content: <InfoBarPanel />,
		},
	];

	return <Tabs ariaLabel={t("admin_panel")} tabs={tabs} />;
};

export default Dashboard;
